// extracted by mini-css-extract-plugin
export default {"wrapper":"row_actions-module___wrapper___be71810c"};